var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length > 0)?_c('ul',{class:[
    'hierarchical-list',
    _vm.level > 0 && ['list', 'child'],
    ['list', `lvl${_vm.level}`],
  ]},_vm._l((_vm.items),function(item){return _c('li',{key:item.value,class:[
      'item',
      item.data && item.data.length > 0 && ['item', 'parent'],
      item.isRefined && ['item', 'selected'],
    ]},[_c('a',{class:['link', item.isRefined && ['link', 'font-weight-bold']],attrs:{"href":_vm.createURL(item.value)},on:{"click":function($event){$event.preventDefault();return _vm.refine(item.value)}}},[_c('b-form-checkbox',{attrs:{"checked":item.isRefined}},[_vm._v("\n        "+_vm._s(item.label)+"\n        "),_c('span',{staticClass:"badge badge-pill badge-primary"},[_vm._v(_vm._s(item.count))])])],1),_vm._v(" "),(item.data)?_c('styled-hierarchical-menu-list',{attrs:{"items":item.data,"level":_vm.level + 1,"refine":_vm.refine,"createURL":_vm.createURL}}):_vm._e()],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }